import { jsx as _jsx } from "react/jsx-runtime";
import { FileImage } from '~/views/molecules/file-image';
import { EFileExtension, EFileSize, EFileType, FILE_WITH_COPYRIGHT_PREFIX } from '~/shared/types';
import { getCoverLink, getFileExtension, getFileLink } from '~/tools/file';
import { useService } from '~/services/service.base';
import { ServiceConfig } from '~/services/service.config';
import { observer } from 'mobx-react-lite';
export const BookSheetContentSection = observer(({ document, clickByImageHandler }) => {
    const serviceConfig = useService(ServiceConfig);
    return (_jsx(FileImage, { clickImageHandler: clickByImageHandler, item: {
            extension: document?.fileExtension || EFileExtension.zip,
            title: document?.name || '',
            fileType: document?.objType || EFileType.archive,
            depository: '',
            id: String(document?.id || ''),
            date: String(document?.cdate || ''),
            eventLocation: '',
            author: '',
            physicalForm: '',
            physicalFormCode: '',
            versement: '',
            dateVersement: null,
            valorisation: null,
            cerfaNumber: null,
            cerfaDate: null,
            userId: String(document?.userId || ''),
            img: getCoverLink(document?.path || '', serviceConfig.awsUrl, '', `_${EFileSize.big}`),
            fileLink: getFileLink(`${document?.objType === EFileType.image
                ? document?.path + '_' + EFileSize.large + FILE_WITH_COPYRIGHT_PREFIX
                : document?.path || ''}`, serviceConfig.awsUrl, getFileExtension(document?.objType || EFileType.archive, document?.fileExtension || EFileExtension.jpg), document?.objType || EFileType.image),
            name: document?.name || '',
        } }));
});
